type MixpanelLogSource = "client" | "server";

export const isMixpanelProduction = process.env.NEXT_PUBLIC_APP_ENV === "production";

export function logMixpanelDevEvent(
  source: MixpanelLogSource,
  eventName: string,
  properties: Record<string, unknown>,
) {
  if (isMixpanelProduction) return;

  console.log(`[Mixpanel DEV][${source}] ${eventName}`, properties);
}
